import React, { useState } from 'react';
import { cadastroService } from '../../services/api';
import DraggableWindow from './DraggableWindow';

// Campos enviados ao salvar — devem bater com a allowlist do proxy.
// (Tributos/kit/promoções ficam de fora: têm cálculo fiscal no ERP.)
const CAMPOS = [
  'NOME', 'NOMEC', 'BARRA', 'BAR1', 'BAR2', 'BAR3', 'BAR4',
  'NCM', 'CEST', 'RMS', 'CODFOR',
  'CDGRUPO', 'CDFAMIL', 'CDMARCA', 'CDFORNE', 'CDCOND',
  'EMBCOM', 'EMBVEN', 'EMBEXP', 'QTDCOM', 'QTDEXP',
  'PESO', 'ALTURA', 'LARGURA', 'COMPRIMENTO',
  'PRECO', 'CUSLIQ', 'CUSMED', 'MARGEM', 'FABR', 'PMPF',
  'FGATIVO', 'FGCONTROLADO', 'FGTARJADO', 'FGFORADELINHA', 'PSICOTROPICO',
  'TPRECEITA', 'DOSAGEM', 'REFRIGERADO',
];
const FLAGS = ['FGATIVO', 'FGCONTROLADO', 'FGTARJADO', 'FGFORADELINHA', 'PSICOTROPICO', 'REFRIGERADO'];
const FLAG_LABEL = {
  FGATIVO: 'Ativo', FGCONTROLADO: 'Controlado', FGTARJADO: 'Tarjado',
  FGFORADELINHA: 'Fora de linha', PSICOTROPICO: 'Psicotrópico', REFRIGERADO: 'Refrigerado',
};

const WindowCadProduto = ({ onClose, onMinimize, isMinimized, zIndex, onFocus }) => {
  const [termo, setTermo] = useState('');
  const [resultados, setResultados] = useState([]);
  const [form, setForm] = useState(null);
  const [buscando, setBuscando] = useState(false);
  const [salvando, setSalvando] = useState(false);
  const [erro, setErro] = useState('');
  const [sucesso, setSucesso] = useState('');
  // Foto do produto
  const [fotoUrl, setFotoUrl] = useState(null);
  const [fotoFile, setFotoFile] = useState(null);
  const [exibirSite, setExibirSite] = useState(false);
  const [salvandoFoto, setSalvandoFoto] = useState(false);
  const [atualizandoSite, setAtualizandoSite] = useState(false);
  const [fotoMsg, setFotoMsg] = useState('');

  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const carregarFoto = async (cdprodu) => {
    setFotoFile(null); setFotoMsg('');
    const url = await cadastroService.buscarFotoProduto(cdprodu);
    setFotoUrl(url);
  };

  const aoEscolherFoto = (e) => {
    const f = e.target.files?.[0];
    if (!f) return;
    setFotoFile(f);
    setFotoUrl(URL.createObjectURL(f)); // preview local
    setFotoMsg('');
  };

  const salvarFoto = async () => {
    if (!form?.CDPRODU || !fotoFile) { setFotoMsg('Escolha uma imagem primeiro (Ler Imagem).'); return; }
    setSalvandoFoto(true); setFotoMsg('');
    try {
      const r = await cadastroService.salvarFotoProduto(form.CDPRODU, fotoFile, exibirSite);
      setFotoMsg(`Foto gravada (${Math.round(r.bytes / 1024)} KB).`);
      setFotoFile(null);
      await carregarFoto(form.CDPRODU); // recarrega do servidor
    } catch (e) {
      setFotoMsg(e.message || 'Erro ao gravar a foto.');
    } finally {
      setSalvandoFoto(false);
    }
  };

  const atualizarSite = async () => {
    if (!form?.CDPRODU) return;
    if (!window.confirm(`Publicar o produto ${form.CDPRODU} no site agora?`)) return;
    setAtualizandoSite(true); setFotoMsg('');
    try {
      await cadastroService.atualizarSiteProduto(form.CDPRODU);
      setFotoMsg('Enviado ao site. Em até ~30s o site estará atualizado.');
    } catch (e) {
      setFotoMsg(e.message || 'Não foi possível conectar com o site.');
    } finally {
      setAtualizandoSite(false);
    }
  };

  const buscar = async () => {
    setErro(''); setSucesso(''); setResultados([]); setForm(null);
    if (!termo.trim()) { setErro('Informe o código, código de barras ou nome do produto.'); return; }
    setBuscando(true);
    try {
      const rows = await cadastroService.buscarProduto(termo);
      if (!rows || rows.length === 0) setErro('Nenhum produto encontrado.');
      else if (rows.length === 1) carregar(rows[0]);
      else setResultados(rows);
    } catch (e) {
      setErro(e.message || 'Erro ao buscar.');
    } finally {
      setBuscando(false);
    }
  };

  const carregar = (p) => {
    setResultados([]); setForm({ ...p });
    setExibirSite(String(p.FOTOSITE).toUpperCase() === 'S');
    carregarFoto(p.CDPRODU);
  };

  const salvar = async () => {
    if (!form?.CDPRODU) return;
    if (!String(form.NOME || '').trim()) { setErro('Informe a descrição do produto.'); return; }
    setErro(''); setSucesso('');
    const campos = {};
    CAMPOS.forEach((k) => { campos[k] = FLAGS.includes(k) ? (form[k] || 'N') : (form[k] ?? ''); });
    setSalvando(true);
    try {
      await cadastroService.salvarProduto(form.CDPRODU, campos);
      setSucesso(`Produto ${form.CDPRODU} alterado com sucesso.`);
    } catch (e) {
      setErro(e.message || 'Erro ao salvar.');
    } finally {
      setSalvando(false);
    }
  };

  const lbl = { display: 'block', fontSize: 11, fontWeight: 600, color: '#475569', marginBottom: 3 };
  const inp = { width: '100%', padding: '7px 9px', border: '1px solid #cbd5e1', borderRadius: 6, fontSize: 13, boxSizing: 'border-box' };
  const sec = { fontSize: 12, fontWeight: 700, color: '#0078d7', margin: '14px 0 8px', borderBottom: '1px solid #e2e8f0', paddingBottom: 4 };
  const F = ({ k, label, w = 1, readOnly = false, type = 'text' }) => (
    <div style={{ flex: w, minWidth: 90 }}>
      <label style={lbl}>{label}</label>
      <input style={{ ...inp, background: readOnly ? '#f1f5f9' : '#fff' }} type={type}
        value={form?.[k] ?? ''} readOnly={readOnly} onChange={(e) => set(k, e.target.value)} />
    </div>
  );

  return (
    <DraggableWindow title="Alteração de Cadastro — Produto" icon="fa-box"
      onClose={onClose} onMinimize={onMinimize} isMinimized={isMinimized}
      zIndex={zIndex} onFocus={onFocus} initialWidth={820}>
      <div style={{ padding: 16 }}>
        {/* Busca */}
        <div style={{ display: 'flex', gap: 8, marginBottom: 14 }}>
          <input style={{ ...inp, flex: 1 }} value={termo} placeholder="Código, código de barras, RMS ou nome do produto..."
            onChange={(e) => setTermo(e.target.value)}
            onKeyDown={(e) => { if (e.key === 'Enter') buscar(); }} autoFocus />
          <button onClick={buscar} disabled={buscando}
            style={{ padding: '8px 16px', border: 'none', borderRadius: 6, background: '#0078d7', color: '#fff', cursor: 'pointer' }}>
            {buscando ? '...' : 'Buscar'}
          </button>
        </div>

        {resultados.length > 0 && (
          <div style={{ border: '1px solid #e2e8f0', borderRadius: 8, marginBottom: 14, maxHeight: 220, overflowY: 'auto' }}>
            {resultados.map((p) => (
              <div key={p.CDPRODU} onClick={() => carregar(p)}
                style={{ padding: '8px 10px', borderBottom: '1px solid #f1f5f9', cursor: 'pointer', fontSize: 13 }}>
                <b>{p.CDPRODU}</b> — {p.NOME} {p.BARRA ? `· ${p.BARRA}` : ''}
              </div>
            ))}
          </div>
        )}

        {form && (
          <>
            <div style={sec}>Identificação</div>
            <div style={{ display: 'flex', gap: 10, marginBottom: 10 }}>
              <F k="CDPRODU" label="Código" w={0.6} readOnly />
              <F k="NOME" label="Descrição" w={3} />
              <F k="NOMEC" label="Nome curto" w={1.4} />
            </div>
            <div style={{ display: 'flex', gap: 10, marginBottom: 10 }}>
              <F k="BARRA" label="Barra principal" />
              <F k="BAR1" label="Barra 2" /><F k="BAR2" label="Barra 3" />
              <F k="BAR3" label="Barra 4" /><F k="BAR4" label="Barra 5" />
              <F k="RMS" label="RMS" />
            </div>

            <div style={sec}>Classificação fiscal e comercial</div>
            <div style={{ display: 'flex', gap: 10, marginBottom: 10 }}>
              <F k="NCM" label="NCM" /><F k="CEST" label="CEST" />
              <F k="CDGRUPO" label="Grupo" /><F k="CDFAMIL" label="Família" />
              <F k="CDMARCA" label="Marca" /><F k="CDFORNE" label="Fornecedor" />
            </div>
            <div style={{ display: 'flex', gap: 10, marginBottom: 10 }}>
              <F k="CDCOND" label="Condição" />
              <F k="CODFOR" label="Cód. Fornecedor" /><F k="TPRECEITA" label="Tipo Receita" />
              <F k="DOSAGEM" label="Dosagem" w={1.5} />
            </div>

            <div style={sec}>Embalagens</div>
            <div style={{ display: 'flex', gap: 10, marginBottom: 10 }}>
              <F k="EMBCOM" label="Emb. Compra" /><F k="EMBVEN" label="Emb. Venda" />
              <F k="EMBEXP" label="Emb. Expedição" /><F k="QTDCOM" label="Qtd Compra" />
              <F k="QTDEXP" label="Qtd Expedição" />
            </div>

            <div style={sec}>Dimensões / peso</div>
            <div style={{ display: 'flex', gap: 10, marginBottom: 10 }}>
              <F k="PESO" label="Peso" /><F k="ALTURA" label="Altura" />
              <F k="LARGURA" label="Largura" /><F k="COMPRIMENTO" label="Comprimento" />
            </div>

            <div style={sec}>Valores (edição direta — não recalcula tributo)</div>
            <div style={{ display: 'flex', gap: 10, marginBottom: 10 }}>
              <F k="PRECO" label="Preço Venda" /><F k="CUSLIQ" label="Custo Líquido" />
              <F k="CUSMED" label="Custo Médio" /><F k="MARGEM" label="Margem %" />
              <F k="FABR" label="Fábrica/PMC" /><F k="PMPF" label="PMPF" />
            </div>

            <div style={sec}>Indicadores</div>
            <div style={{ display: 'flex', gap: 16, flexWrap: 'wrap', marginBottom: 14 }}>
              {FLAGS.map((k) => (
                <label key={k} style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 13, color: '#334155' }}>
                  <input type="checkbox"
                    checked={String(form[k]).toUpperCase() === 'S'}
                    onChange={(e) => set(k, e.target.checked ? 'S' : 'N')} />
                  {FLAG_LABEL[k]}
                </label>
              ))}
            </div>

            <div style={sec}>Foto do Produto</div>
            <div style={{ display: 'flex', gap: 16, marginBottom: 14, alignItems: 'flex-start' }}>
              <div style={{ width: 140, height: 140, border: '1px solid #cbd5e1', borderRadius: 8, background: '#f8fafc', display: 'flex', alignItems: 'center', justifyContent: 'center', overflow: 'hidden', flexShrink: 0 }}>
                {fotoUrl
                  ? <img src={fotoUrl} alt="Foto do produto" style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }} />
                  : <span style={{ fontSize: 12, color: '#94a3b8' }}>Sem imagem</span>}
              </div>
              <div style={{ flex: 1 }}>
                <label style={{ display: 'inline-block', padding: '8px 14px', border: '1px solid #0078d7', borderRadius: 6, color: '#0078d7', cursor: 'pointer', fontSize: 13, fontWeight: 600 }}>
                  <i className="fas fa-image" /> Ler Imagem...
                  <input type="file" accept="image/png,image/jpeg,image/bmp,image/gif" style={{ display: 'none' }} onChange={aoEscolherFoto} />
                </label>
                <label style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 13, color: '#334155', margin: '10px 0' }}>
                  <input type="checkbox" checked={exibirSite} onChange={(e) => setExibirSite(e.target.checked)} /> Exibir Foto no Site
                </label>
                <div style={{ display: 'flex', gap: 8 }}>
                  <button onClick={salvarFoto} disabled={salvandoFoto || !fotoFile}
                    style={{ padding: '8px 14px', border: 'none', borderRadius: 6, background: (!salvandoFoto && fotoFile) ? '#16a34a' : '#94a3b8', color: '#fff', cursor: (!salvandoFoto && fotoFile) ? 'pointer' : 'not-allowed', fontSize: 13, fontWeight: 600 }}>
                    {salvandoFoto ? 'Gravando...' : 'Salvar Foto'}
                  </button>
                  <button onClick={atualizarSite} disabled={atualizandoSite}
                    style={{ padding: '8px 14px', border: '1px solid #0078d7', borderRadius: 6, background: '#fff', color: '#0078d7', cursor: 'pointer', fontSize: 13, fontWeight: 600 }}>
                    {atualizandoSite ? 'Enviando...' : 'Atualizar Site'}
                  </button>
                </div>
                {fotoMsg && <div style={{ fontSize: 12, color: '#475569', marginTop: 8 }}>{fotoMsg}</div>}
              </div>
            </div>

            <button onClick={salvar} disabled={salvando}
              style={{ width: '100%', padding: 12, border: 'none', borderRadius: 8, background: salvando ? '#94a3b8' : '#16a34a', color: '#fff', fontWeight: 700, fontSize: 15, cursor: salvando ? 'not-allowed' : 'pointer' }}>
              {salvando ? 'Salvando...' : 'Salvar Alterações'}
            </button>
            <div style={{ fontSize: 11, color: '#94a3b8', marginTop: 8 }}>
              ⚠️ Esta tela grava os valores como digitados. Tributos (ICMS/ST/PIS/COFINS/CST), kit e promoções
              continuam sendo calculados no sistema oficial — não são alterados aqui.
            </div>
          </>
        )}

        {erro && <div style={{ background: '#fee2e2', color: '#b91c1c', padding: '8px 12px', borderRadius: 6, marginTop: 12, fontSize: 13 }}><i className="fas fa-triangle-exclamation" /> {erro}</div>}
        {sucesso && <div style={{ background: '#dcfce7', color: '#166534', padding: '8px 12px', borderRadius: 6, marginTop: 12, fontSize: 13 }}><i className="fas fa-check-circle" /> {sucesso}</div>}
      </div>
    </DraggableWindow>
  );
};

export default WindowCadProduto;
